export const UpToTop = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.63522 24.6996L16.0454 15.402L25.3648 24.6661" stroke="currentColor" stroke-width="2"/>
<path d="M28 9L4 9" stroke="currentColor" stroke-width="2"/>
</svg>`;
